import { createRoutine } from 'redux-saga-routines';

export const fetchSettings = createRoutine('FETCH_SETTINGS');
